import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme) => ({
  root: {
    // width: '100%',
    // padding: '16px',
    // paddingTop: 30,
    // paddingBottom: '45px',
    // [theme.breakpoints.down('sm')]: {
    //   padding: 8,
    //   paddingTop: 30
    // }
    height: '100%',
    width: '100%',
    display: 'flex',
    flexDirection: 'column'
  },
}));